window.addEventListener("DOMContentLoaded", () => {
    const review_containers = document.querySelectorAll('.review-container')
    review_containers.forEach(review_container => {
        const prev = review_container.querySelector('.prev')
        const next = review_container.querySelector('.next')
        const slidetrack = review_container.querySelector('.slider-container')
        let slideWidth = slidetrack.querySelector('.review').getBoundingClientRect().width
        const current_slide_text = review_container.querySelector('.current-slide-text')
        const numberOfSlide = slidetrack.querySelectorAll('.review').length
        const readMoreBtns = slidetrack.querySelectorAll('.read-more')
        const slides = slidetrack.querySelectorAll('.review')

        let pos = 0;
        let oldPos = 0;
        let translate = 0;

        updateCurrentSlideText(current_slide_text, 1, numberOfSlide)
        checkControlBtn(pos+1, numberOfSlide)
        prev.addEventListener('click',()=>{
            console.log('back')
            back();
        })
        next.addEventListener('click',()=>{
            console.log('forward')
            forward();
        })
        function back(){
            oldPos = pos
            pos = pos - 1
            translate = -1 * ((pos * slideWidth) + (pos * 30))
            slidetrack.setAttribute('style',`transform: translateX(${translate}px)`)
            updateCurrentSlideText(current_slide_text, pos + 1, numberOfSlide)
            checkControlBtn(pos+1, numberOfSlide)
            resetContent()
        }
        function forward(){
            oldPos = pos
            pos = pos + 1
            translate = -1 * ((pos * slideWidth) + (pos * 30))
            slidetrack.setAttribute('style',`transform: translateX(${translate}px)`)
            updateCurrentSlideText(current_slide_text, pos + 1, numberOfSlide)
            checkControlBtn(pos+1, numberOfSlide)
            resetContent()
        }
        window.addEventListener('resize',()=>{
            slideWidth = slidetrack.querySelector('.review').getBoundingClientRect().width
            translate = -1 * ((pos * slidetrack) + (pos * 30))
            slidetrack.setAttribute('style',`transform: translateX(${translate}px)`)
        })
        function updateCurrentSlideText(textWrapper, curSlide, numSlide){
            textWrapper.innerHTML = curSlide + ' / ' + numSlide
        }
        function checkControlBtn(curPos, numSlide){
            if(curPos <= 1){
                prev.classList.add('inactive')
            }else{
                prev.classList.remove('inactive')
            }
            if(curPos >=numSlide){
                next.classList.add('inactive')
            }else{
                next.classList.remove('inactive')
            }
        }
        function resetContent(){
            slides.forEach(element => {
                element.querySelector('.truncate-copy').classList.remove('hidden')
                element.querySelector('.full-copy').classList.add('hidden')
            });
        }
        readMoreBtns.forEach(element => {
            element.addEventListener('click',()=>{
                // toggle read full/less
                if(element.parentElement.parentElement.querySelector('.truncate-copy').classList.contains('hidden')){
                    element.innerHTML = "Read Full Review"
                }else{
                    element.innerHTML = "Read Less Review"
                }
                element.parentElement.parentElement.querySelector('.truncate-copy').classList.toggle('hidden')
                element.parentElement.parentElement.querySelector('.full-copy').classList.toggle('hidden')
            })
        });
    });
});